// Modul Reservations – i18n manifest (veřejný kontrakt pro composition)

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'reservations';

export const reservationsI18nManifest: SliceI18nManifest = {
  owner: 'modules/reservations',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
